var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionModelList", {
        attrs: {
          modelList: _vm.modelList,
          categoryList: _vm.categoryList,
          manufacturerList: _vm.manufacturerList,
          shouldShowSearch: true,
          toolbarActions: [
            {
              text: "Model",
              icon: "add",
              iconColor: "success",
              emitEvent: "onAddNewModelClicked",
            },
          ],
          isLoading: _vm.isLoading,
        },
        on: {
          onAddNewModelClicked: function ($event) {
            _vm.showDialogFormModelAdd = true
          },
          onEditModelClicked: (val) => [
            (_vm.modelToEdit = val.modelToEdit),
            (_vm.showDialogFormModelEdit = true),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormModelAdd", {
        attrs: {
          showDialog: _vm.showDialogFormModelAdd,
          categoryList: _vm.categoryList,
          manufacturerList: _vm.manufacturerList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormModelAdd = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormModelAddSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormModelEdit", {
        attrs: {
          showDialog: _vm.showDialogFormModelEdit,
          modelToEdit: _vm.modelToEdit,
          categoryList: _vm.categoryList,
          manufacturerList: _vm.manufacturerList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormModelEdit = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormModelEditSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }